import { Skeleton, Stack } from "@mui/material";
import * as React from "react";

interface TableSkeletonProps {
  height?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ height = 300 }) => {
  return (
    <Stack sx={{ height, width: "100%" }} spacing={3} py={2}>
      <Skeleton variant="rounded" width="80%" />
      <Skeleton variant="rounded" width="70%" />
    </Stack>
  );
};

export default TableSkeleton;
